import { startOfMonth, startOfQuarter, startOfYear, sub } from "date-fns";
import { PaginationType, RollbarDataType } from "../types/common";

export const HEADER_HEIGHT = "45px";

export enum LOADING_STATES {
  INIT = 3,
  SUCCESS = 2,
  LOADING = 1,
  FAILED = 0,
}

//TODO: create a function with pagesize param
export const INITIAL_PAGINATION: PaginationType<any> = {
  list: null,
  totalPageCount: null,
  currentPageNo: 1,
  pageSize: 30,
  changingPage: false,
  fetchingList: false,
  count: 0,
};

export const INITIAL_PAGINATION_15_ITEMS: PaginationType<any> = {
  ...INITIAL_PAGINATION,
  pageSize: 15,
};

export type CodemirrorTheme = "light" | "dark";

export enum ALERT_TYPE {
  DELETE = "delete",
  REMOVE = "remove",
}

export const DeletionLabels = {
  [ALERT_TYPE.DELETE]: {
    label: "Delete",
    title: "deletion",
  },
  [ALERT_TYPE.REMOVE]: {
    label: "Remove",
    title: "removal",
  },
};

export enum CODEMIRROR_SIZE {
  SINGLE_LINE = "single-line",
  TEXT_AREA = "text-area",
  EDITOR = "editor",
  MINI_EDITOR = "mini-editor",
}

export const PRODUCTION_HOST = "app.inflection.io";
export const STAGING_HOST = "app.inflectionapp.net";

export enum FILE_UPLOAD_STATUS {
  PROCESSING = "processing",
  COMPLETED = "completed",
  ERROR = "error",
}

export enum ASSET_TYPES {
  CAMPAIGN = "campaign",
  TEMPLATE = "template",
  TOKEN = "token",
  STATIC_LIST = "static_list",
  WEBHOOK = "webhook",
}

export enum TAG_CONNECTOR {
  AND = "AND",
  OR = "OR",
}

export enum CUSTOM_DATE_RANGE_LABELS {
  LAST_DAY = "Last one day",
  LAST_WEEK = "Last one week",
  ONE_MONTH = "This month so far",
  LAST_ONE_MONTH = "Last one month",
  QUARTER = "This quarter so far",
  LAST_6_MONTHS = "Last 6 months",
  YEAR_SO_FAR = "This year so far",
  LAST_YEAR = "Last one year",
  ALL_TIME = "All Time",
}

export function getStartDate(label: CUSTOM_DATE_RANGE_LABELS): Date {
  // returns the start date of the custom ranges
  // as of now end date = new Date() for all ranges

  switch (label) {
    case CUSTOM_DATE_RANGE_LABELS.LAST_DAY:
      return sub(new Date(), { days: 1 });
    case CUSTOM_DATE_RANGE_LABELS.LAST_WEEK:
      return sub(new Date(), { weeks: 1 });
    case CUSTOM_DATE_RANGE_LABELS.ONE_MONTH:
      return startOfMonth(new Date());
    case CUSTOM_DATE_RANGE_LABELS.LAST_ONE_MONTH:
      return sub(new Date(), { months: 1 });
    case CUSTOM_DATE_RANGE_LABELS.QUARTER:
      return startOfQuarter(new Date());
    case CUSTOM_DATE_RANGE_LABELS.LAST_6_MONTHS:
      return sub(new Date(), { months: 6 });
    case CUSTOM_DATE_RANGE_LABELS.YEAR_SO_FAR:
      return startOfYear(new Date());
    case CUSTOM_DATE_RANGE_LABELS.LAST_YEAR:
      return sub(new Date(), { years: 1 });
    case CUSTOM_DATE_RANGE_LABELS.ALL_TIME:
      return new Date(0);
  }
}

export const DEFAULT_RETRY_COUNT = 3;

export const HAS_REFRESHED = "has_refreshed";

export const INIT_ROLLBAR_DATA: RollbarDataType = {
  id: "",
  username: "",
  email: "",
  organisation_id: "",
  organisation_name: "",
};
